import { updateObject } from '../../helpers/utility.helper';
import { initialState } from '../state/sensorData.state';
import sensorDataType from '../types/sensorData.type';
import ISensorDataState from '../models/ISensorDataState';

const getSensorDataStart = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            error: null, loading: true, success: false,
        })
    });
};

const getSensorDataSuccess = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            datas: action.payload,
            error: null,
            success: true,
            loading: false
        })
    });
};

const getSensorDataError = (oldState: ISensorDataState, action: any) => {
    return updateObject(oldState, {
        sensorDataList: updateObject(oldState.sensorDataList, {
            error: action.payload,
            success: false,
            loading: false
        })
    });
};

const sensorDataReducer = (oldState: ISensorDataState = initialState, action: any) => {
    switch (action.type) {
        case sensorDataType.GET_SENSOR_DATA_START: return getSensorDataStart(oldState, action);
        case sensorDataType.GET_SENSOR_DATA_SUCCESS: return getSensorDataSuccess(oldState, action);
        case sensorDataType.GET_SENSOR_DATA_ERROR: return getSensorDataError(oldState, action);
        default: return oldState;
    }
};
export default sensorDataReducer;